import { Injector } from "@angular/core";
import { SponsorEntityListView } from "../../../Data/MedicinalProductData/SponsorEntityListView";
import { SimpleSearchListNode } from "../../SimpleSearchListNode";
import { EntityEnum } from "../../EntityEnum";
import { SponsorAutoUploadEntity } from "../Entity/SponsorAutoUploadEntity";
import { BaseNode } from "../../BaseNode";

export class TreeNodeMedicinalProductsSponsor extends SimpleSearchListNode {

    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new SponsorEntityListView(items), 'Sponsors', useHist ? EntityEnum.sponsorHist : EntityEnum.sponsor);
        this.useHist = useHist;
    }

    override addChild(model: any): BaseNode|undefined{
        const labelTemplate =  `${model.ev_Code} - ${model.name_Org}`;
        return this.addChildNode(SponsorAutoUploadEntity,labelTemplate, this,model, false, false, false);
        // add specific nodes for this entity
    }

    override getCriteriaFields(): string[] {
        return ['ev_Code','name_Org'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for sponsors available in the XEVMPD [visibility restrictions may apply] including those owned by your HQ";
    }
}